import { action, atom } from '@reatom/framework'
import * as R from 'radash'

// TODO: Use tauri specific api - blur/focus

type ActivityState = 'idle' | 'active'
const init: ActivityState = 'active'
export const userActivityStateAtom = atom<ActivityState>(
  init,
  'userActivityStateAtom',
)

const ACTIVITY_EVENTS = ['touchstart', 'touchmove', 'focus']

const INACTIVITY_DELAY = 30_000

export const listenActivityState = action((ctx) => {
  let intervalId: number | undefined = undefined

  const handleActivityEvent = () => {
    userActivityStateAtom(ctx, 'active')
    if (intervalId) {
      window.clearTimeout(intervalId)
    }
    intervalId = window.setTimeout(() => {
      userActivityStateAtom(ctx, 'idle')
    }, INACTIVITY_DELAY)
  }

  const handleActivityEventThrottled = R.throttle(
    { interval: 1000 },
    handleActivityEvent,
  )

  for (const event of ACTIVITY_EVENTS) {
    window.addEventListener(event, handleActivityEventThrottled, {
      passive: true,
    })
  }
}, 'listenActivityState')
